import axios from 'axios';
import { AxiosRequestConfig, AxiosPromise } from 'axios';
import { GlobalUrls } from './Constants/constants';

export const AjaxUtils = {

    axiosGet: function (url: string, config: AxiosRequestConfig): AxiosPromise {
        var finalUrl = AjaxUtils.getFinalUrl(url);
        return axios.get(finalUrl, config);
    },

    axiosDelete: function (url: string, config: AxiosRequestConfig): AxiosPromise {
        var finalUrl = AjaxUtils.getFinalUrl(url);
        return axios.delete(finalUrl, config);
    },

    axiosPut: function (url: string, data: any, config: AxiosRequestConfig): AxiosPromise {
        var finalUrl = AjaxUtils.getFinalUrl(url);
        return axios.put(finalUrl, data, config);
    },

    axiosPost: function (url: string, data: any, config: AxiosRequestConfig): AxiosPromise {
        var finalUrl = AjaxUtils.getFinalUrl(url);
        return axios.post(finalUrl, data, config);
    },

    axiosRequest: function (url, config: AxiosRequestConfig): AxiosPromise {
        var finalUrl = AjaxUtils.getFinalUrl(url);

        if (config == null) {
            config = {
                url: finalUrl
            }
        }
        else {
            config.url = url;
        }

        return axios.request(config);
    },

    getFinalUrl: function (url) {

        var baseUrl = GlobalUrls.API_BASE_URL;

        if (baseUrl[baseUrl.length - 1] != "/") {
            baseUrl += "/";
        }

        var finalUrl = baseUrl + url;

        return finalUrl;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/utils.tsx